import Button from '@mui/material/Button';
import Highcharts from 'highcharts';
import HighchartsExportData from 'highcharts/modules/export-data';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsReact from 'highcharts-react-official';
import Paper from '@mui/material/Paper';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { CSVLink } from 'react-csv';
import { Card, CardBody, Col, Row, Spinner } from 'reactstrap';

HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

// Columns definition for DataGrid
const columns = [
  { field: 'sno', headerName: 'S.no', width: 100 },
  { field: 'university', headerName: 'University', width: 200 },
  // { field: "course", headerName: "Course", width: 200 },
  {
    field: 'tteacher',
    headerName: 'Total Teachers',
    width: 150,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },
  { field: 'engStudent', headerName: 'Engaged Students', width: 180 },
  { field: 'sucCall', headerName: 'Successful Calls', width: 150 },
  { field: 'srmgs', headerName: 'Total Email/SMS Sent/Received', width: 200 },
  { field: 'avgTime', headerName: 'Avg Time Per Call', width: 180 },
];

const SummaryTable = ({ engagementMetricsTable }) => {
  // Map the data from engagementMetricsTable to DataGrid rows
  const tableRows = engagementMetricsTable
    .filter((entry) => entry.university_name) // Filter out entries without a university name
    .map((entry, index) => ({
      id: index + 1,
      sno: index + 1,
      university: entry.university_name,
      tteacher: entry.total_teachers,
      engStudent: entry.students_engaged,
      sucCall: entry.successful_calls,
      srmgs: entry.total_messages_sent_received,
      avgTime: entry.average_time_per_call,
    }));

  const [paginationModel, setPaginationModel] = useState({
    page: 0, // Starts at the first page
    pageSize: 1, // Shows 20 rows by default
  });

  // Prepare data for CSV download
  const csvData = [
    [
      'S.no',
      'University',
      'Total Teacher',
      'Engaged Students',
      'Successful Calls',
      'Send/Received Messages',
      'Avg. Time per Call',
    ],
    ...tableRows.map((row) => [
      row.sno,
      row.university,
      row.tteacher,
      row.engStudent,
      row.sucCall,
      row.srmgs,
      row.avgTime,
    ]),
  ];

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', boxShadow: 'none' }}>
      <div style={{ width: '100%' }}>
        <div className="d-flex justify-content-end mb-2">
          {/* <CSVLink
          data={csvData}
          filename={"engagement_metrics_report.csv"}
         
          className="btn" 
          style={{ border: '1px solid #ddd',width:'fit-content', borderRadius: '6px', padding: '4px 8px' }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
          </svg>
        </CSVLink> */}
        </div>
        <DataGrid
          rows={tableRows} // Use tableRows instead of hardcoded rows
          columns={columns}
          pagination
          paginationModel={paginationModel}
          onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
          autoHeight
          rowCount={tableRows.length} // Ensure correct total row count
          pageSizeOptions={[20, 50, 100]} // Available page sizes
          sx={{
            'fontFamily': 'Nunito Sans, sans-serif',
            'fontSize': '14px',
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#ebebeb',
              color: '#000',
              fontWeight: 'bold',
              fontSize: '14px',
              padding: '6px',
              fontFamily: 'Nunito Sans, sans-serif',
            },
            '& .MuiDataGrid-cell': {
              padding: '6px',
              fontFamily: 'Nunito Sans, sans-serif',
              fontSize: '14px',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
        />
      </div>
    </Paper>
  );
};

const OverView = ({
  selectedUniversities,
  selectedTimelines,
  selectedTerms,
  selectedUnits,
  selectedPrograms,
  loading,
  resetTrigger
}) => {
  const [metricsDataTable, setmetricsDataTable] = useState(null); // State to store metrics data
  // const [loading, setLoading] = useState(true); // New loading state
  const [metricsData, setMetricsData] = useState(null);
  const [chartOptions, setChartOptions] = useState({});
  const [hasError, setHasError] = useState(false); // State to track error
  const [groupChartOptions, setGroupChartOptions] = useState(null);

  useEffect(() => {
    resetData();
  }, [resetTrigger]);
  const resetData = () => {
    // setmetricsDataTable(null);
    setmetricsDataTable({ engagementMetricsTable: [] }); // Set an empty table
    setMetricsData(null);
    setHasError(false); // Reset the error state
    // Set default chart with empty bars
    setChartOptions({
      chart: {
        type: 'column',
        backgroundColor: 'transparent',
        marginTop: 40,
      },
      title: {
        text: null,
      },
      xAxis: {
        categories: ['Audio', 'Video'],
        title: {
          text: 'Session Type',
        },
      },
      yAxis: [
        {
          
          title: {
            text: 'Duration (Mins)',
          },
          min: 0,
          max: 10, // Set a small max value for an empty chart
        },
        {
          opposite: true,

          title: {
            text: 'Duration (Mins)',
          },
          min: 0,
          max: 10, // Set a small max value for an empty chart
        },

      ],
      series: [
        {
          name: 'Total Durations (Mins)',
          type: 'column',
          data: [0, 0], // Empty bars
          color: {
            linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
            stops: [
              [0, '#E1EAF9'],
              [1, '#B5D0FB'],
            ],
          },
          pointWidth: 10,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return `${this.y} mins`; // Show zero mins
            },
          },
        },
        {
          name: 'Total Successful Sessions',
          type: 'line',
          data: [0, 0], // Empty lines
          color: '#FF9FA2',
          dataLabels: {
            enabled: true,
            formatter: function () {
              return `${this.y} successful`; // Show zero successful calls
            },
          },
        },
      ],
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
    });

    // 🔹 Reset Group Session Chart also
    setGroupChartOptions({
      chart: {
        type: "column",
        height: "100%",
        spacingTop: 10,
        spacingBottom: 10,
      },
      title: { text: "" },
      credits: { enabled: false },
      exporting: { enabled: true },
      xAxis: {
        categories: ["Group Sessions"],
      },
      yAxis: [
        { title: { text: "Duration (Mins)" }, min: 0 },
        { title: { text: "Count" }, opposite: true, min: 0 }
      ],
      tooltip: {
        shared: true,
        useHTML: true,
        formatter() {
          return `
          <div style="text-align:left;">
            Session Count: <b>0</b>
          </div>
        `;
        }
      },
      series: [
        {
          name: "Duration (Mins)",
          type: "column",
          data: [0],
          pointWidth: 10,
          color: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, "#E1EAF9"],
              [1, "#B5D0FB"],
            ],
          },
        },
        {
          name: "Session Count",
          type: "scatter",
          yAxis: 1,
          data: [],
          dataLabels: { enabled: false },
          marker: {
            radius: 7,
            fillColor: "#FF9FA2",
            lineColor: "#FF9FA2",
          },
          dataLabels: {
            enabled: true,
            formatter() {
              return "0";
            }
          }
        },
      ],
    });
  };
  const user_token = localStorage.getItem('usertoken');
  //charts
  useEffect(() => {
    const fetchData = async () => {
      try {
        const selectUNiversities = Array.from(selectedUniversities);
        const selectedTimeline = Array.from(selectedTimelines);
        const config = {
          headers: {
            Authorization: `Token ${user_token}`,
          },
        };

        const payload = {
          university:
            selectedUniversities.size > 0
              ? Array.from(selectedUniversities)
              : null,
          program:
            selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
          year:
            selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
          term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,
          unit: selectedUnits.size > 0 ? Array.from(selectedUnits) : null,
        };
        const response = await axios.post(
          process.env.REACT_APP_API_BASE_URL + 'metrics/',
          payload,
          config
        );
        if (response === 500) {
          resetData();
          return;
        }
        if (response && response.data) {
          const responseData = response.data[0];

          // Safely access and map the response data, removing unnecessary fields and appending only "Engagement_metrics_table"
          const metricsTable = {
            engagementMetricsTable:
              responseData?.Engagement_metrics_table || [],
          };

          setmetricsDataTable(metricsTable);

          const groupSessions =
            responseData?.group_sessions || {
              group_session_count: 0,
              group_session_duration: 0,
            };

          const groupSessionDuration = parseFloat(groupSessions.group_session_duration) || 0;
          const groupSessionCount = groupSessions.group_session_count || 0;


          const audioVideoDurationCount =
            responseData?.Audio_video_duration_count || {
              audio_call_time: '0 mins',
              audio_call_successful_count: 0,
              video_call_time: '0 mins',
              video_call_successful_count: 0,
            };

          const audioDuration =
            parseInt(audioVideoDurationCount.audio_call_time.total_duration) ||
            0; // Convert duration to number
          const audioSuccessful =
            audioVideoDurationCount.audio_call_successful_count || 0;
          const videoDuration =
            parseInt(audioVideoDurationCount.video_call_time.total_duration) ||
            0; // Convert duration to number
          const videoSuccessful =
            audioVideoDurationCount.video_call_successful_count || 0;

          // Update metrics data
          const metrics = {
            averageSatisfactionScore: responseData?.Avg_Satisfaction_score || {
              mid_term: 0,
              end_term: 0,
            },
            audioVideoDurationCount,
            totalMessages: responseData?.Total_messages || {
              messages_sent: 0,
              messages_received: 0,
            },
            // messageResponsiveness: responseData?.Message_responsiveness || {
            //   "0-1hrs": "0%",
            //   "1-2hrs": "0%",
            //   "2-3hrs": "0%",
            //   "above_6_hrs": "0%",
            //   "not_responded": "100%",
            // },
            studentsEngagedPercentage:
              responseData?.studends_engaged_percentage || {
                new: '0%',
                returning: '0%',
                total: '0%',
              },
            censusDropRatePercentage:
              responseData?.census_drop_rate_percentage || {
                new: '0%',
                returning: '0%',
                total: '0%',
              },
            unitCompletionRatePercent:
              responseData?.unit_completion_rate_percentage || {
                new: '0%',
                returning: '0%',
                total: '0%',
              },
          };

          setMetricsData(metrics); // Update the state with the structured metrics
          setChartOptions(
            combinedChartOptions2(
              audioDuration,
              audioSuccessful,
              videoDuration,
              videoSuccessful,
            ),
          ); // Set updated chart options
          setGroupChartOptions(
            groupSessionChartOptions(
              groupSessionDuration,
              groupSessionCount
            )
          );

        }
      } catch (error) {
        console.error('Error fetching data:', error);
        resetData();
      } finally {
      }
    };

    fetchData();
  }, [selectedUniversities, selectedPrograms, selectedTimelines]);

  //charts
  // const totalMessagesOptions = {
  //   chart: {
  //     type: "bar",
  //     borderRadius: 8,
  //     // height: 540,

  //     // Removed height property for natural sizing
  //   },
  //   title: {
  //     text: null,
  //   },
  //   xAxis: {
  //     categories: ["Sent", "Received"],
  //     title: {
  //       text: null,
  //     },
  //     labels: {
  //       useHTML: true,
  //       formatter: function () {
  //         return this.value.replace(" ", "<br>");
  //       },
  //       style: {
  //         fontSize: "13px",
  //         width: "72px",
  //         textAlign: "right",
  //       },
  //     },
  //   },
  //   yAxis: {
  //     min: 0,
  //     title: {
  //       text: null,
  //     },
  //     labels: {
  //       format: "{value}",
  //       style: {
  //         fontSize: "12px",
  //       },
  //     },
  //   },
  //   plotOptions: {
  //     bar: {
  //       dataLabels: {
  //         enabled: true,
  //       },
  //       borderRadius: 5, // Rounded bars
  //     },
  //     tooltip: {
  //       pointFormat: "<b>{point.y}</b>",
  //       style: {
  //         fontSize: "14px",
  //       },
  //     },
  //   },
  //   series: [
  //     {
  //       name: 'Total Messages Sent/ Received',
  //       colorByPoint: true,
  //       data: [
  //         metricsData ? metricsData.totalMessages.messages_sent : 0,
  //         metricsData ? metricsData.totalMessages.messages_received : 0,
  //       ],
  //       colorByPoint: true,
  //       pointWidth: '10',
  //       colors: [
  //         {
  //           linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
  //           stops: [
  //             [0, '#FFE9D6'],  // Start color
  //             [1, '#FFD29E']   // End color
  //           ]
  //         },
  //         {
  //           linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
  //           stops: [
  //             [0, 'rgba(230,238,255,1)'],  // Start color
  //             [1, 'rgba(180,200,255,1)']   // End color
  //           ]
  //         }
  //       ]
  //     },
  //   ],
  //   legend: {
  //     enabled: false,
  //   },
  //   credits: {
  //     enabled: false,
  //   },
  //   exporting: {
  //     enabled: true,
  //     chartOptions: {
  //       title: {
  //         text: 'Total Messages Exchanged',
  //       },
  //     },
  //   },

  // };

  const totalMessagesOptions = {
    chart: {
      type: 'pie',
      borderRadius: 8,
    },
    title: {
      text: null, // No main title on top
    },
    plotOptions: {
      pie: {
        innerSize: '90%', // Creates the donut hole
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.y}', // Sent: 10
          style: {
            fontSize: '12px',
            color: '#000000',
          },
        },
        showInLegend: true, // Show legend
      },
    },
    series: [
      {
        name: 'Messages',
        colorByPoint: true,
        data: [
          {
            name: 'Sent',
            y: metricsData ? metricsData.totalMessages.messages_sent : 0,
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
              stops: [
                [0, '#FFE9D6'],
                [1, '#FFD29E'],
              ],
            },
          },
          {
            name: 'Received',
            y: metricsData ? metricsData.totalMessages.messages_received : 0,
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 1, y2: 0 },
              stops: [
                [0, '#EBFFEE'],
                [1, '#A2EAB3'],
              ],
            },
          },
          // {
          //   name: "Total",
          //   y: (metricsData ? metricsData.totalMessages.messages_sent : 0) +
          //     (metricsData ? metricsData.totalMessages.messages_received : 0),
          //   color: "#D3D3D3", // Grey color for Total
          // },
        ],
      },
    ],
    tooltip: {
      pointFormat: '<b>{point.y}</b>',
      style: {
        fontSize: '14px',
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Total Messages Exchanged',
        },
      },
    },
    // Custom text in the center to show Total
    events: {
      load: function () {
        const total =
          (metricsData ? metricsData.totalMessages.messages_sent : 0) +
          (metricsData ? metricsData.totalMessages.messages_received : 0);
        this.renderer
          .text(
            `Total:<br><b>${total}</b>`,
            this.chartWidth / 2 - 30,
            this.chartHeight / 2,
          )
          .css({
            color: '#000000',
            fontSize: '14px',
            textAlign: 'center',
          })
          .add();
      },
    },
  };

  const combinedChartOptions = (
    audioDuration,
    audioSuccessful,
    videoDuration,
    videoSuccessful,
  ) => ({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      marginTop: 40, // Adjust this value to increase or decrease space
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: ['Audio', 'Video'],
      title: {
        text: 'Session Type',
      },
    },
    yAxis: {
      title: {
        text: 'Duration (Mins)',
      },
      min: 0,
      max:
        Math.max(
          audioDuration,
          videoDuration,
          audioSuccessful,
          videoSuccessful,
        ) + 10,
    },
    series: [
      {
        name: 'Total Session Duration',
        type: 'column',
        data: [audioDuration, videoDuration],
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#E1EAF9'],
            [1, '#B5D0FB'],
          ],
        },
        pointWidth: 10,
        dataLabels: {
          enabled: true,
          formatter: function () {
            return `${this.y} mins`; // Show total duration in mins
          },
        },
      },
      {
        name: 'Total Successful Sessions',
        type: 'line',
        data: [audioSuccessful, videoSuccessful],
        color: '#FF9FA2',
        dataLabels: {
          enabled: true,
          formatter: function () {
            return `${this.y} successful`; // Show successful call count
          },
        },
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: '',
        },
        // Include data table
        data: {
          table: {
            rows: [
              ['Session Type', 'Total Duration (min)', 'Successful Calls'],
              ['Audio', audioDuration, audioSuccessful],
              ['Video', videoDuration, videoSuccessful],
            ],
          },
        },
      },
    },
  });

const combinedChartOptions2 = (
  audioDuration,
  audioSuccessful,
  videoDuration,
  videoSuccessful,
) => {
  const maxDuration = Math.max(audioDuration, videoDuration);
  const maxCount = Math.max(audioSuccessful, videoSuccessful);

  return {
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      marginTop: 40,
    },

    title: {
      text: '',
    },

    xAxis: {
      categories: ['Audio', 'Video'],
      title: {
        text: 'Session Type',
      },
    },

    yAxis: [
      {
        title: {
          text: 'Duration (Mins)',
        },
        min: 0,
        max: Math.ceil(maxDuration / 10) * 10, // 🔹 dynamic & rounded
        allowDecimals: false,
      },
      {
        title: {
          text: 'Sessions Count',
        },
        opposite: true,
        min: 0,
        max: Math.ceil(maxCount / 1), // 🔹 dynamic whole numbers
        allowDecimals: false,
        gridLineWidth: 0,
      },
    ],

    series: [
      {
        name: 'Total Durations (Mins)',
        type: 'column',
        yAxis: 0,
        data: [audioDuration, videoDuration],
        pointWidth: 10,
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#E1EAF9'],
            [1, '#B5D0FB'],
          ],
        },
        dataLabels: {
          enabled: true,
          formatter() {
            return `${this.y} mins`;
          },
        },
      },
      {
        name: 'Total Successful Sessions',
        type: 'line',
        yAxis: 1,
        data: [audioSuccessful, videoSuccessful],
        color: '#FF9FA2',
        marker: {
          radius: 6,
        },
        dataLabels: {
          enabled: true,
          formatter() {
            return `${this.y}`;
          },
        },
      },
    ],

    credits: {
      enabled: false,
    },

    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: '1-1 Sessions',
        },
        data: {
          table: {
            rows: [
              ['Session Type', 'Total Duration (min)', 'Successful Calls'],
              ['Audio', audioDuration, audioSuccessful],
              ['Video', videoDuration, videoSuccessful],
            ],
          },
        },
      },
    },
  };
};

  // const groupSessionChartOptions = (duration, count) => ({
  //  chart: {
  //   type: "column",
  //   height: "100%",
  //   spacingTop: 10,
  //   spacingBottom: 10,
  // },

  //   title: { text: "" },
  //   credits: { enabled: false },
  //   exporting: { enabled: true }, // ✔ enable export
  //   xAxis: {
  //     categories: ["Group Sessions"],
  //   },
  //   yAxis: [
  //     {
  //       title: { text: "Duration (Mins)" },
  //     },
  //     {
  //       title: { text: "Count" },
  //       opposite: true,
  //     },
  //   ],
  //   tooltip: {
  //   shared: true,
  //   useHTML: true,
  //   formatter: function () {
  //     const pts = this.points || [this.point];
  //     let isDot = pts.length === 1 && pts[0].series.type === "scatter";

  //     let sessionCount = "";
  //     let duration = "";

  //     pts.forEach(point => {
  //       if (point.series.type === "scatter") {
  //         sessionCount = `<b>${point.y}</b>`;
  //       }
  //       if (point.series.type === "column") {
  //         duration = `<b>${point.y} mins</b>`;
  //       }
  //     });

  //     // 🎯 Hover dot: only show session count
  //     if (isDot) {
  //       return `
  //         <div style="text-align:left;">
  //           Session Count: ${sessionCount}
  //         </div>
  //       `;
  //     }

  //     // Hover column: show both
  //     return `
  //       <div style="text-align:left;">
  //         Duration: ${duration}
  //       </div>
  //     `;
  //   }
  // },

  //   colors: ["#6D9FF5", "#FF9FA2"], // fallback colors
  //   series: [
  //     {
  //       name: "Duration (Mins)",
  //       type: "column",
  //       data: [duration],
  //       pointWidth: 10, // ✔ bar width
  //       color: {
  //         linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
  //         stops: [
  //           [0, "#E1EAF9"], // ✔ gradient start
  //           [1, "#B5D0FB"], // ✔ gradient end
  //         ],
  //       },
  //     },
  //     {
  //       name: "Session Count",
  //       type: "scatter",
  //       yAxis: 1,
  //       data: [count],
  //       marker: {
  //         radius: 7,
  //         fillColor: "#FF9FA2", // ✔ dot color
  //         lineColor: "#FF9FA2",
  //       },
  //     },

  //   ],
  // });

  const groupSessionChartOptions = (duration, count) => ({
    chart: {
      type: "column",
      height: "100%",
      spacingTop: 10,
      spacingBottom: 10,
    },

    title: { text: "" },
    credits: { enabled: false },
    exporting: { enabled: true },

    xAxis: {
      categories: ["Group Sessions"],
      labels: { style: { fontSize: "12px" } },
    },

    yAxis: [
      {
        title: { text: "Duration (Mins)" },
        min: 0
      },
      {
        title: { text: "Sessions Count" },
        opposite: true,
        min: 0
      },
    ],

    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const pts = this.points || [this.point];
        let isDot = pts.length === 1 && pts[0].series.type === "scatter";

        let sessionCount = "";
        let duration = "";

        pts.forEach((point) => {
          if (point.series.type === "scatter") sessionCount = `<b>${point.y}</b>`;
          if (point.series.type === "column") duration = `<b>${point.y} mins</b>`;
        });

        if (isDot) return `<div style="text-align:left;">Session Count: ${sessionCount}</div>`;
        return `<div style="text-align:left;">Duration: ${duration}<br/>Session Count: ${sessionCount}</div>`;
      },
    },

    colors: ["#6D9FF5", "#FF9FA2"],

    plotOptions: {
      column: {
        pointWidth: 10,
        dataLabels: {
          enabled: true,
          color: "#000",
          formatter: function () {
            return this.y;
          },
          inside: false,
        },
        pointPadding: 0.2,
        groupPadding: 0.1,
      },
      scatter: {
        dataLabels: {
          enabled: true,
          color: "#000",
          formatter: function () {
            // Only show label if y is a number
            return typeof this.y === "number" && !isNaN(this.y) ? this.y : null;
          },
          align: "center",
          verticalAlign: "bottom",
          y: -5,
        },
        marker: {
          radius: 7,
          fillColor: "#FF9FA2",
          lineColor: "#FF9FA2"
        },
      },
    },



    series: [
      {
        name: "Duration (Mins)",
        type: "column",
        yAxis: 0,
        data: [duration || 0],
        color: {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, "#E1EAF9"],
            [1, "#B5D0FB"],
          ],
        },
      },
      {
        name: "Total Sessions",
        type: "scatter",
        yAxis: 1,
        data: [count],
        marker: {
          radius: 7,
          fillColor: "#FF9FA2",
          lineColor: "#FF9FA2"
        },
        dataLabels: {
          enabled: true,
          formatter() {
            return this.point.y;
          }
        }
      }

    ],

    responsive: {
      rules: [
        {
          condition: { maxWidth: 500 },
          chartOptions: {
            xAxis: { labels: { style: { fontSize: "10px" } } },
            plotOptions: {
              scatter: { marker: { radius: 5 } },
            },
          },
        },
      ],
    },
  });



  return (
    <Row className="g-2 ">

      <Col md={4} className="mb-0">
        <Card className="mb-0 h-100 border box-shadow-none">
          {loading ? ( // Show loader while loading
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: '200px' }}
            >
              <Spinner style={{ width: '3rem', height: '3rem' }} />
            </div>
          ) : (
            <CardBody>
              <div className="">
                <h5 className="f-16 bold d-flex align-items-center mb-3">
                  1-1 Sessions
                </h5>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={chartOptions}
                />
              </div>
            </CardBody>
          )}
        </Card>
      </Col>
      <Col md={4} className="">
        <Card className="mb-0 h-100 border box-shadow-none">
          {loading ? ( // Show loader while loading
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: '200px' }}
            >
              <Spinner style={{ width: '3rem', height: '3rem' }} />
            </div>
          ) : (
            <CardBody className="">
              <h5 className="f-16 bold d-flex align-items-center  mb-3">
                Total Messages Exchanged
              </h5>
              <HighchartsReact
                highcharts={Highcharts}
                options={totalMessagesOptions}
              />
            </CardBody>
          )}
        </Card>
      </Col>
      <Col md={4}>
        <Card className="mb-0 h-100 border box-shadow-none">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
              <Spinner style={{ width: '3rem', height: '3rem' }} />
            </div>
          ) : (
            <CardBody>
              <h5 className="f-16 bold d-flex align-items-center mb-3">
                Group Sessions
              </h5>
              {groupChartOptions && (
                <HighchartsReact highcharts={Highcharts} options={groupChartOptions} />
              )}
            </CardBody>
          )}
        </Card>
      </Col>

    </Row>
  );
};

export default OverView;
